import { BaseEntity } from "@app/models/rest/base-entity";
import { LocationModel } from "@app/models/rest/location";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRelType
} from "@lagoshny/ngx-hateoas-client";
import { Job_EmbeddedVisitProjection } from "@app/models/rest/visit";

@HateoasResource("meetings")
export class Meeting extends BaseEntity {
  externalPropertyReference: string;
  planningWindowEnd: Date;
  planningWindowStart: Date;
  location: LocationModel;
  hasLocation: boolean;
  description: string;
}

@HateoasProjection(Meeting, "basic")
export class Meeting_BasicProjection extends BaseEntity {
  externalPropertyReference: string;
  location: ProjectionRelType<LocationModel>;
  hasLocation: boolean;
  description: string;
}

@HateoasProjection(Meeting, "detail")
export class Meeting_DetailProjection extends BaseEntity {
  externalPropertyReference: string;
  location: ProjectionRelType<LocationModel>;
  hasLocation: boolean;
  description: string;
  visitList: Array<Job_EmbeddedVisitProjection>;
}
